import {
    Autocomplete, Box, IconButton, Table, TableBody, TableCell, TableHead,
    TableRow, TextField, Typography, Tooltip, Accordion, AccordionSummary,
    AccordionDetails, ButtonGroup, Button, Dialog
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import '../UmaDocNotes.css';
import { COMMON_STYLE, SPH_OPTIONS, CYL_OPTIONS, AXIS_OPTIONS, BCDVA_OPTIONS, BCNVA, UCVA_OPTIONS } from '../../../../Utility/Constants';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';

const refracArr = [
    { "eye_type": "RE", "UCVA": "", "SPH": "", "CYL": "", "AXIS": "", "target": "", "BCDVA": "" },
    { "eye_type": "LE", "UCVA": "", "SPH": "", "CYL": "", "AXIS": "", "target": "", "BCDVA": "" },
]

const eyeObj = { "distance": "", "near": "" }

const headers = ['Eye', 'UCVA', 'SPH', 'CYL', 'AXIS', 'Target', 'BCDVA'];

const eyeHeaders = ['Eye', "BEVN"]

const deepCopyFunc = (arr) => {
    return JSON.parse(JSON.stringify(arr))
}

const UmaPresbyond = React.forwardRef((props, ref) => {
    const [presbyond, setPresbyond] = useState({
        SPHList: SPH_OPTIONS,
        CYLList: CYL_OPTIONS,
        AXISList: AXIS_OPTIONS,
        BCDVAList: BCDVA_OPTIONS,
        BCNVAList: BCNVA,
        UCVAList: UCVA_OPTIONS,
        comments: '',
        prevComments: '',
        dominantEye: "RE",
        prevDominantEye: "",
        refractionData: deepCopyFunc(refracArr),
        prevRefractionData: [],
        eyeData: deepCopyFunc(eyeObj),
        prevEyeData: {},
        openCompareRefracPopup: false,
        openCompareEyePopup: false,
        loadScreen: false,
        enableCopyRefrac: false,
        enableCopyEye: false,
        enableCompareRefrac: false,
        enableCompareEye: false,
        dupDominantEye: "",
        dupComments: '',
        dupRefractionData: [],
        dupEyeData: {},
        id: null,
        accordionOpen: false,
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: `${message} - Presbyond`,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: `${message} - Presbyond`,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    React.useImperativeHandle(ref, () => ({
        performPresbyondAction: () => {
            if (
                (JSON.stringify(presbyond.comments) !== presbyond.dupComments) ||
                (JSON.stringify(presbyond.refractionData) !== presbyond.dupRefractionData) ||
                (JSON.stringify(presbyond.eyeData) !== presbyond.dupEyeData)
            ) {
                postPresbyondData()
            }
        },
        setAccordionOpen: (isOpen) => {
            setPresbyond((prev) => ({ ...prev, accordionOpen: isOpen }));
        }
    }))

    const apicalls = async () => {
        await getPresbyond()
        await getPrevPresbyond()
    }

    const hasNonEmptyFields = (data) =>
        Array.isArray(data) && data.some(item =>
            item?.UCVA || item?.Target || item?.SPH ||
            item?.CYL|| item?.AXIS || item?.BCDVA
        );

    const hasValue = (obj) => Object.values(obj)?.some(item => item);

    useEffect(() => {

        if (presbyond.prevRefractionData && presbyond.prevEyeData && presbyond.refractionData && presbyond.eyeData) {
            setPresbyond((prev) => ({
                ...prev,
                enableCopyRefrac: hasNonEmptyFields(presbyond.prevRefractionData),
                enableCopyEye: hasValue(presbyond.prevEyeData),
                enableCompareRefrac: hasNonEmptyFields(presbyond.refractionData),
                enableCompareEye: hasValue(presbyond.eyeData),
            }))
        }
    }, [presbyond.prevRefractionData, presbyond.prevEyeData, presbyond.eyeData, presbyond.refractionData])

    const getPresbyond = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PRESBYOND + '?appointment_id=' + props.props.appointment_id + '&doctor_id=' + props?.props?.doctorID)
            if (response?.data?.status === 'success') {
                const Data = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                const isDataAvailable = (Data?.comment && Data?.comments?.trim()) || (Data?.dominant_eye && Data?.dominant_eye?.trim()) ||
                    hasNonEmptyFields(Data?.refraction) || (Data?.bevn && hasValue(Data?.bevn));
                setPresbyond((prev) => ({
                    ...prev,
                    id: Data?.id,
                    comments: Data?.comment ? Data?.comment : '',
                    dominantEye: Data?.dominant_eye ? Data?.dominant_eye : 'RE',
                    refractionData: Data?.refraction?.length > 0 ? Data?.refraction : deepCopyFunc(refracArr),
                    eyeData: Data?.bevn ? Data?.bevn : deepCopyFunc(eyeObj),
                    dupDominantEye: Data?.comment ? JSON.stringify(Data?.comment) : '',
                    dupComments: Data?.dominant_eye ? JSON.stringify(Data?.dominant_eye) : '',
                    dupRefractionData: Data?.refraction?.length > 0 ? JSON.stringify(Data?.refraction) : JSON.stringify(refracArr),
                    dupEyeData: Data?.bevn ? JSON.stringify(Data?.bevn) : JSON.stringify(eyeObj),
                    accordionOpen: isDataAvailable,
                }))
                props.syncAccordionOpen?.(isDataAvailable);
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error?.message)
        }
    }

    const getPrevPresbyond = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PREV_PRESBYOND +
                '?appointment_id=' + props.props.appointment_id + '&patient_id=' + props.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
            )
            if (response?.data?.status === 'success') {
                const Data = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                setPresbyond((prev) => ({
                    ...prev,
                    prevComments: Data?.comment?.length > 0 ? Data?.comment : '',
                    prevDominantEye: Data?.dominant_eye ? Data?.dominant_eye : '',
                    prevRefractionData: Data?.refraction?.length > 0 ? Data?.refraction : [],
                    prevEyeData: Data?.bevn ? Data?.bevn : {},
                }))
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error?.message)
        }
    }

    const postPresbyondData = async () => {
        try {
            const data = {
                "id": presbyond?.id,
                "appointment_id": props.props?.appointment_id,
                "comments": presbyond?.comments,
                "dominant_eye": presbyond?.dominantEye,
                "refraction": presbyond?.refractionData,
                "bevn": presbyond?.eyeData,
            }
            const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_PRESBYOND)
            if (response?.data?.status === 'success') {
                successMessage(response?.data?.message)
                await getPresbyond()
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error?.message)
        }
    }

    const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index, arr) => {
        try {
            return (
                <Autocomplete
                    disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                    clearIcon
                    size='small'
                    sx={{ width: arr === "eyeData" ? '10dvw' : '4.85dvw' }}
                    value={values || ""}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
                    onChange={(e, newValue) => {
                        if (arr === "eyeData") {
                            setPresbyond((prev) => ({
                                ...prev,
                                [arr]: {
                                    ...prev[arr],
                                    [names]: newValue?.label || "",
                                },
                            }));
                        } else {
                            let updateArr = [...presbyond[arr]];
                            updateArr[index] = {
                                ...updateArr[index],
                                [names]: newValue?.label || "",
                            };
                            setPresbyond((prev) => ({
                                ...prev,
                                [arr]: updateArr,
                            }));
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const textBox = (names, values, placeholder, index, arr) => {
        try {
            return (
                <TextField
                    disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                    variant='outlined'
                    size='small'
                    sx={{ width: "4.85dvw" }}
                    value={values}
                    placeholder={placeholder}
                    InputProps={{
                        style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                    name={names}
                    inputProps={{ maxLength: 50 }}
                    onChange={(e) => {
                        let updateArr = [...presbyond[arr]];
                        updateArr[index] = {
                            ...updateArr[index],
                            [names]: e.target.value,
                        };
                        setPresbyond((prev) => ({
                            ...prev,
                            [arr]: updateArr,
                        }));
                    }}
                />
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    const renderLabel = (label, enableCopy, enableCompare, openComparePopup, arrKey, prevArrKey) => {
        return (
            <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>{label}</Typography>
                <Box component={'div'} display={'flex'} alignItems={'center'} ml={'0.5rem'}>
                    <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_cpy'
                        disabled={!presbyond[enableCopy] || props?.props?.patient_transfered || props?.props?.isLocked}
                        onClick={() => setPresbyond((prev) => ({
                            ...prev, [openComparePopup]: false,
                            [arrKey]: prev[prevArrKey]
                        }))}
                    ><ContentCopyIcon color={!presbyond[enableCopy] ? '' : 'primary'} /></IconButton></Tooltip>
                    <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_vis'
                        onClick={() => setPresbyond((prev) => ({ ...prev, [openComparePopup]: true }))}
                        disabled={!(presbyond[enableCopy] && presbyond[enableCompare]) || props?.props?.patient_transfered || props?.props?.isLocked}
                    ><VisibilityIcon color={!(presbyond[enableCopy] && presbyond[enableCompare]) ? '' : 'primary'} /></IconButton></Tooltip>
                </Box>
            </Box>
        )
    }

    const renderHeader = (headArr) => {
        return (
            <TableHead>
                <TableRow>
                    {headArr.map((text, idx) => (
                        <TableCell className='doc_notes_tbl_header' key={idx}>{text}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    const commonTblCopyCompare = () => {
        try {
            return (
                <Box component={'div'} marginY={"0.625dvw"}>
                    {renderLabel("Refraction", "enableCopyRefrac", "enableCompareRefrac", "openCompareRefracPopup", "refractionData", "prevRefractionData")}
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            {renderHeader(headers)}
                            <TableBody>
                                {presbyond?.refractionData?.length > 0 ? presbyond?.refractionData?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('UCVA', item?.UCVA, presbyond?.UCVAList, 'label', 'UCVA', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, presbyond?.SPHList, 'label', 'SPH', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, presbyond?.CYLList, 'label', 'CYL', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, presbyond?.AXISList, 'label', 'AXIS', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {textBox('target', item?.target, 'Target', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('BCDVA', item?.BCDVA, presbyond?.BCDVAList, 'label', 'BCDVA', index, "refractionData")}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderEyeData = () => {
        try {
            return (
                <Box component={'div'} marginBottom={"0.625dvw"}>
                    {renderLabel("Eye", "enableCopyEye", "enableCompareEye", "openCompareEyePopup", "eyeData", "prevEyeData")}
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            {renderHeader(eyeHeaders)}
                            <TableBody>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>Distance</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>
                                        {autocompleteTextBox('distance', presbyond?.eyeData?.distance, presbyond?.BCDVAList, 'label', 'Distance', 0, "eyeData")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>Near</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>
                                        {autocompleteTextBox('near', presbyond?.eyeData?.near, presbyond?.BCNVAList, 'label', 'Near', 0, "eyeData")}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderTable = (arrKey) => {
        return (
            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                    {renderHeader(headers)}
                    <TableBody>
                        {presbyond[arrKey]?.map((item, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.UCVA}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.target}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.BCDVA}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </Box>
        )
    }

    const renderEyeTbl = (obj) => {
        return (
            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                    {renderHeader(eyeHeaders)}
                    <TableBody>
                        <TableRow>
                            <TableCell className='doc_notes_tbl_body_cell'>Distance</TableCell>
                            <TableCell className='doc_notes_tbl_body_cell'>{obj?.distance}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className='doc_notes_tbl_body_cell'>Near</TableCell>
                            <TableCell className='doc_notes_tbl_body_cell'>{obj?.near}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
        )
    }

    const renderComparePopup = (label, openKey, arrKey, prevArrKey) => {
        try {
            return (
                <Dialog open={presbyond[openKey]} maxWidth="md" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>{`Compare ${label}`} </Typography>
                            <IconButton emed_tid='cmp_prev_cls'
                                onClick={() => setPresbyond((prev) => ({ ...prev, [openKey]: false }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>{`Current ${label}`}</Typography>
                                <Tooltip placement='top' arrow title={'Copy'}>
                                    <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                                        onClick={() => {
                                            setPresbyond((prev) => ({
                                                ...prev,
                                                [arrKey]: prev[prevArrKey],
                                                [openKey]: false
                                            }))
                                        }}
                                    ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
                            </Box>
                            {label === "Eye" ? renderEyeTbl(presbyond[prevArrKey]) : renderTable(prevArrKey)}
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography className='doc_notes_header_card_font'>{`New ${label}`}</Typography>
                            {label === "Eye" ? renderEyeTbl(presbyond[arrKey]) : renderTable(arrKey)}
                        </Box>
                    </Box>
                </Dialog >
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <ShowComponents onIntersection={apicalls}>
            <Box component={'div'}>
                <Accordion expanded={presbyond.accordionOpen}
                    onChange={(_, isExpanded) => {
                        setPresbyond((prevState) => ({ ...prevState, accordionOpen: isExpanded }));
                        props.syncAccordionOpen?.(isExpanded);
                    }}>
                    <AccordionSummary component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}
                        expandIcon={<ExpandMoreIcon />}>
                        <Typography className='doc_notes_header_card_font'>Presbyond</Typography>
                    </AccordionSummary>
                    <AccordionDetails component={'div'} m={'0.5rem'}>
                        <Box component={'div'} display={'flex'} alignItems={'center'} marginY={"0.5dvw"}>
                            <Typography className='doc_notes_header_card_font'>Dominant</Typography>
                            <ButtonGroup sx={{ marginLeft: "1vw" }}>
                                <Button variant={presbyond.dominantEye === "RE" ? 'contained' : 'outlined'} sx={{ width: "10vw", textTransform: "capitalize" }} onClick={() => { setPresbyond((prevState) => ({ ...prevState, dominantEye: "RE" })) }}>Right Eye</Button>
                                <Button variant={presbyond.dominantEye === "LE" ? 'contained' : 'outlined'} sx={{ width: "10vw", textTransform: "capitalize" }} onClick={() => { setPresbyond((prevState) => ({ ...prevState, dominantEye: "LE" })) }}>Left Eye</Button>
                            </ButtonGroup>
                        </Box>
                        {commonTblCopyCompare("Refraction", "refractionData")}
                        {renderEyeData()}

                        <Box component={'div'}>
                            <TextField
                                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                                size='small'
                                multiline
                                fullWidth
                                rows={6}
                                value={presbyond.comments}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS || value === '') {
                                        setPresbyond((prev) => ({ ...prev, comments: value }))
                                    }
                                }}
                                placeholder='Comments'
                                inputProps={{ maxLength: COMMON_STYLE.CHAR_LIMIT_COMMENTS }}
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>
                {renderComparePopup("Refraction", "openCompareRefracPopup", "refractionData", "prevRefractionData")}
                {renderComparePopup("Eye", "openCompareEyePopup", "eyeData", "prevEyeData")}
                {message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
                {message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            </Box>
        </ShowComponents>
    )
})

export default UmaPresbyond